document.addEventListener('DOMContentLoaded', (event) => {
  const lightboxElements = document.querySelectorAll('.glightbox');
  const groupElements = {};

  // Group lightbox elements by data-group attribute
  lightboxElements.forEach(element => {
    const group = element.getAttribute('data-group');
    if (!groupElements[group]) {
      groupElements[group] = [];
    }
    groupElements[group].push(element);
  });

  Object.keys(groupElements).forEach(group => {
    if (groupElements[group].length === 1) {
      groupElements[group][0].classList.add('single-card-group');
    }

    // Initialize lightbox
    const lightbox = GLightbox({
      selector: `.glightbox[data-group="${group}"]`,
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    });

    // Hide navigation buttons if there is only one element in the group
    if (groupElements[group].length === 1) {
      lightbox.on('open', () => {
        const nextButton = document.querySelector('.gnext');
        const prevButton = document.querySelector('.gprev');
        if (nextButton && prevButton) {
          nextButton.style.display = 'none';
          prevButton.style.display = 'none';
        }

        // Add click event for orientation button
        const orientationButton = document.querySelector('.glightbox .orientation-btn');
        console.log('orientationButton:', orientationButton); // Log the button element

        if (orientationButton) {
          orientationButton.addEventListener('click', (e) => {
            e.preventDefault();

            // Check if screen.orientation.lock is supported
            if (screen.orientation && screen.orientation.lock) {
              const desiredOrientation = window.innerHeight > window.innerWidth ? 'landscape' : 'portrait';
              screen.orientation.lock(desiredOrientation).catch(err => {
                console.error('Error locking orientation:', err);
              });
            } else {
              console.info('Screen orientation lock not supported by this device/browser.');
            }
          });
        }
      });
    }
  });
});